import { AppLanguageCode } from "../api-contract/api-contract";

/** export interface AccessTokenResponse {
    readonly access_token: {
        readonly token: string;
        readonly refreshToken: string;
    };
    readonly user: User;
} */
export interface Response {
    data?: string;
    status: {
        code: number;
        message: string;
        innerMessage?: string;
    };
}

// NOTE: Endpoint for login
/** export type LoginForm = {
    readonly request: {
        readonly url: "/login";
        readonly method: "post";
        readonly body: {
            email: string;
            password: string;
        };
    };
    readonly response: {
        readonly body: AccessTokenResponse;
    };
}; */

// NOTE: Endpoint to get default filters for certain user.
/*
export type GetOurCarsDefaultFilters = {
    readonly request: {
        readonly url: "/default-filters";
        readonly method: "get";
        readonly headers: {
            readonly Authorization: string;
        };
        readonly queryParameters: {
            readonly lang: AppLanguageCode;
        };
    };
    readonly response: {
        readonly headers: {
            readonly "Content-Type": "application/json";
        };
        readonly body: GetOurCarsDefaultFiltersBody;
    };
} */

// NOTE: Endpoint to save default filters for certain user.
/* export type SaveOurCarsDefaultFilters = {
    readonly request: {
        readonly url: "/default-filters";
        readonly method: "post";
        readonly headers: {
            readonly Authorization: string;
        };
        readonly queryParameters: {
            readonly lang: AppLanguageCode;
        };
        readonly body: GetOurCarsDefaultFiltersBody;
    };
}; */

/** NOTE: (POST) pay orders */
export type Pay = {
    readonly request: {
        readonly url: "/pay/{orderID}";
        readonly method: "post";
        readonly headers: {
            readonly Authorization: string;
            readonly lang: string;
        };
        readonly body: {
            readonly carIds: readonly number[];
        };
    };
    readonly response: {
        readonly redirectURL: string;
    };
};

// Welcome page
export enum DashboardLinks {
    my_orders = "my_orders",
    my_documents = "my_documents",
    my_account = "my_account",
    my_company = "my_company",
    my_settings = "my_settings",
    my_favourites = "my_favourites",
}

export type WelcomePageInfo = {
    readonly description: string;
    readonly links_details: Readonly<
        Record<
            | DashboardLinks.my_documents
            | DashboardLinks.my_favourites
            | DashboardLinks.my_settings
            | DashboardLinks.my_account
            | DashboardLinks.my_company,
            {
                readonly description: string;
            }
        >
    >;
};

/** NOTE: (GET) dashboard welcome page details */

export type GetWelcomePageDetails = {
    readonly request: {
        readonly url: "/dashboard/welcome-page/details";
        readonly method: "get";
        readonly headers: {
            readonly Authorization: string;
        };
        readonly queryParams: {
            readonly lang: AppLanguageCode;
        };
    };
    readonly response: {
        readonly body: WelcomePageInfo;
    };
};
